import styled from 'styled-components';
const CollapsableSidebarFadingContent = styled.div.withConfig({
  displayName: "CollapsableSidebarFadingContent",
  componentId: "sc-15zub0g-0"
})(["opacity:", ";transition:opacity 100ms;block-size:100%;inline-size:100%;display:flex;flex-direction:column;justify-content:space-between;"], ({
  hide
}) => hide ? 0 : 1);
export default CollapsableSidebarFadingContent;